import { render, staticRenderFns } from "./AccurateEvidence.vue?vue&type=template&id=25e573e1&scoped=true"
import script from "./AccurateEvidence.vue?vue&type=script&lang=js"
export * from "./AccurateEvidence.vue?vue&type=script&lang=js"
import style0 from "./AccurateEvidence.vue?vue&type=style&index=0&id=25e573e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e573e1",
  null
  
)

export default component.exports